module.exports = __webpack_public_path__ + "media/images/made-trip/voyage-sur-mesure-footer-a9bc5b355afc4c09823914d338da5742.png";